"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSubscriptionType = void 0;
const shared_1 = require("@kvix/shared");
const getSubscriptionType = (stripeProducts) => {
    if (!stripeProducts) {
        return "Free";
    }
    if (stripeProducts.includes(shared_1.StripeProduct.LIVE)) {
        return "Premium";
    }
    else {
        return "Free";
    }
};
exports.getSubscriptionType = getSubscriptionType;
//# sourceMappingURL=subscription.js.map